import { workingDaysBetweenDates } from '../../utils'

const currentTask = (state = {}, action) => {
    switch (action.type) {
        case 'SET_CURRENT_TASK':
            return { ...state, id: action.id }

        case 'SET_CURRENT_TASK_DATES':
            return {
                ...state,
                startDate: action.startDate,
                endDate: action.endDate,
                duration: workingDaysBetweenDates(action.startDate, action.endDate) || 1
            }

        case 'RESET_CURRENT_TASK':
            return { id: null, startDate: null, endDate: null, duration: 0 }

        default:
            return state
    }
}

export default currentTask
